import axios from "axios";

const apiKey = process.env.REACT_APP_API_BASE_URL;

const axiosInstance = axios.create({
  baseURL: apiKey,
});

axiosInstance.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {  
    return response;
  },
  (error) => {    
    return Promise.reject(error);
  }
);

export default axiosInstance;
